module.exports = __webpack_public_path__ + "img/IN.5ad6b8bd.png";